import React, {useEffect, useState, useCallback} from 'react';
import Colors from 'components/Colors.js';
import ipfs from 'decentralized/Ipfs.js';
import ethereum from 'decentralized/ethereum.js';
import {web3} from 'decentralized/web3.js';
import {bytes32ToIPFSHash, ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {SEQUENCE_ANNOTATION} from 'constants/annotation-types.js';
import {connect} from 'react-redux';

const colors = new Colors();
const contentCache = {};

const Annotation = ({annotation, style}) => {
    const [content, setContent] = useState('');
    const [userName, setUserName] = useState('');

    // the piece of data (i.e. project), this comment references,
    // since it can be several
    const [contentReferences, setContentReferences] = useState([]); 

    useEffect(() => {
        let h = web3.utils.fromAscii(annotation.annotationData);
        let hash = bytes32ToIPFSHash(h);
        if (contentCache[hash]) {
            setContent(contentCache[hash]);
        } else {
            ipfs.getJson(hash)
                .then(s => {
                    contentCache[hash] = s;
                    setContent(s);
                });
        }

        ethereum.users.getUserName(annotation.address)
            .then(n => setUserName(n));

    }, [annotation, setContent, setUserName]);

    useEffect(() => {
        ethereum.xanadu.getContentReferences(annotation.annotationData)
            .then(setContentReferences);
    }, [annotation, setContentReferences]);

    return (
        <div
          style={style}
          className="annotation">
          <div className="author">
            {userName}: 
          </div>
          <div className="content">
            {content}
          </div>
          <div className="references">
            {contentReferences.map(
                x =>
                    <div
                      style={{
                          backgroundColor: colors.getColorForHash(x)
                      }}
                      className="dot content-reference"/>)}
          </div>
        </div>
    );
};

export default Annotation;
